import Cache from 'admin/editor/cache';
import { debounce } from 'lodash';

export default class TextElement {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedText = null;
    this.activeElementId = null;
    this.activePosition = null;

    this.cache = new Cache('text');

    this.init();
  }

  init() {
    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on('click', '.add-build-text', this.newElement.bind(this));
    $(document).on(action, '.submit-build-text', this.submitElement.bind(this));
    $(document).on(action, '.cancel-build-text', this.cancelElement.bind(this));
    $(document).on(action, '.delete-build-text', this.deleteElement.bind(this));
    $(document).on(action, '.build-text', this.editElement.bind(this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-text" href="#"><i class="fa fa-pencil"></i>Text</a>';
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.savedText = null;

    let cachedText = this.cache.get('text') || "";

    this.insertText(link.closest('.button-bar, .bottom-button-bar'), cachedText);
    this.learnEditor.editing();
  }

  submitElement(event) {
    event.preventDefault();
    const $element = $(event.currentTarget).closest('.build-text-wrapper');

    var text = tinymce.activeEditor.getContent();
    this.learnEditor.disable_text_editor($('.build-textarea'));

    this.savedText = null;
    this.addText($element, text, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";
    this.learnEditor.save_page("Before Added Text Element");
  }

  editElement(event) {
    event.preventDefault();
    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    let $element = $(event.currentTarget);

    const text = $element.html();

    let cachedText = this.cache.get('text');

    //backup the text, save it in case of cancelling, we back up the original
    //text that was saved, and not the cached text
    this.savedText = text;
    this.activeElementId = $element.attr('id');
    this.activePosition = $element.data('position');
    this.insertText($element, cachedText || text);
    this.learnEditor.centerInView($('.build-text-wrapper'));
    this.learnEditor.editing();
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    this.learnEditor.disable_text_editor($('.build-textarea'));

    //restore with global saved text
    this.addText($element.closest('.build-text-wrapper'),
                  this.savedText,
                  this.activeElementId,
                  this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.finishEditing();
    this.cache.delete();
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    this.learnEditor.disable_text_editor($('.build-textarea'));

    $element.closest('.build-text-wrapper').remove();

    this.savedText = null;
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Deleted Text Element");
    this.cache.delete();
  }

  insertText($element, text) {
    const buildText = this.buildText(text);

    $element.hide();
    let $build_text = $(buildText).hide();
    $element.replaceWith($build_text);
    this.learnEditor.enable_text_editor($('#editor'));

    $('.build-text-wrapper').show();

    this.watchState($build_text);
    this.learnEditor.centerInView($('.build-text-wrapper'));
  }

  watchState($element) {
    var saveState = function(event) {
      var text = tinymce.activeEditor.getContent();
      this.cache.save({ text: text });
    }

    tinymce.activeEditor.on('keyup', debounce(saveState.bind(this), 500));
  }

  buildText(text = "") {
    text = text.replace(/'/g, "&#39;").trim();

    let buildText =
      `<div class='row-fluid build-text-wrapper'>
        <textarea id='editor' class='build-textarea span12' style='display=block;'>${text}</textarea>
        <div class="editor-buttons">
          <button class='delete-build-text delete'>Delete</button>
          <button class='cancel-build-text cancel'>Cancel</button>
          <button class='submit-build-text save'>Save</button>
        </div>
      </div>`;

    let $buildText = $(buildText);

    return $buildText;
  }

  addText($element, text, id, position) {
    if (text) {
      text = $.trim(text);
    }

    let textHtml =
      `<div id='${id || ''}' class='element row-fluid text-element build-text' data-position='${position}'>
        ${text}
      </div>`;

    if (text) {
      $element.replaceWith(textHtml);
    } else {
      $element.remove();
    }
  }
}
